import "./styles.less";

import { Button, Card, Col, Row, Space, Tag, Typography } from "antd";
import React, { ReactNode } from "react";

import { CheckOutlined } from "@ant-design/icons";
import { parseMoney } from "../../../../Utils/Functions";
import { useTheme } from "../../../../Styles/ThemeHook";

export interface PricingCardProps {
	title: string;
	subtitle?: string | false;
	price: number;
	currency?: string;
	tax?: string | false;
	bullets?: Array<string>;
	callToAction?: string | ReactNode | false;
	action?: () => void;
	highlight?: string | false;
}

export const PricingCard = ({
	title,
	subtitle = false,
	price,
	currency = "USD",
	tax = "IVA INC",
	bullets = [],
	callToAction = false,
	action = () => {},
	highlight = false,
}: PricingCardProps) => {
	const { theme } = useTheme();
	return (
		<Card
			className={"pricing-card" + (highlight ? " highlight" : "")}
			bordered
			cover={
				<>
					{highlight ? (
						<Tag color={theme.colors.secondaryColor} className={"highlight-tag"}>
							{highlight}
						</Tag>
					) : null}
					<Row gutter={[0, theme.spacing.xsSpacing]}>
						<Col span={24}>
							<Typography.Title level={4} style={{ textAlign: "center", margin: 0 }}>
								{title}
							</Typography.Title>
							{subtitle && (
								<Typography.Text
									style={{ textAlign: "center", margin: 0, display: "block" }}>
									{subtitle}
								</Typography.Text>
							)}
						</Col>
						<Col span={24}>
							<Row
								align={"middle"}
								justify={"center"}
								gutter={theme.spacing.mdSpacing}>
								<Col>
									<Typography.Text
										strong
										style={{
											fontSize: theme.fontSizes.smFontSize,
											textAlign: "right",
											display: "block",
										}}>
										{currency}
									</Typography.Text>
								</Col>
								<Col>
									<Typography.Title
										level={2}
										style={{
											margin: 0,
											display: "block",
											textAlign: "center",
										}}>
										{parseMoney(price)}
									</Typography.Title>
								</Col>
								{tax && (
									<Col>
										<Typography.Text
											type={"secondary"}
											strong
											style={{
												fontSize: theme.fontSizes.smFontSize,
												textAlign: "left",
												display: "block",
											}}>
											{tax}
										</Typography.Text>
									</Col>
								)}
							</Row>
						</Col>
					</Row>
				</>
			}
			children={
				<Row gutter={[0, theme.spacing.lgSpacing]} className={"container-row"}>
					<Col span={24}>
						<Row gutter={[0, theme.spacing.mdSpacing]}>
							{bullets.map((e, i) => {
								return (
									<Col key={`bullet-${e}-${i}`} span={24}>
										<Space size={theme.spacing.mdSpacing} align={"baseline"}>
											<CheckOutlined
												style={{ color: theme.colors.secondaryColor }}
											/>
											<Typography.Text>{e}</Typography.Text>
										</Space>
									</Col>
								);
							})}
						</Row>
					</Col>
					{callToAction && (
						<Col span={24}>
							<Button
								size={"large"}
								type={highlight ? "primary" : "default"}
								className={"secondary"}
								children={callToAction}
								style={{ width: "100%" }}
								onClick={action}
							/>
						</Col>
					)}
				</Row>
			}
		/>
	);
};
